import { parseRouteParamToEnum } from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

import { ListingsSearchCategory } from './ListingsSearch';

export type ListingsSearchSitemapBySearchCategoryRouteParams = {
  searchCategory: ListingsSearchCategory;
};

export type ListingsSearchSitemapBySearchCategoryRouteParamsString = {
  cityOrSearchCategory: string;
};

export const ListingsSearchSitemapBySearchCategory = defineRoute<
  ListingsSearchSitemapBySearchCategoryRouteParams,
  ListingsSearchSitemapBySearchCategoryRouteParamsString
>({
  pathname: '/sitemap/[cityOrSearchCategory]', // for this route [citySlugOrListingTypeID] means `cityOrSearchCategory`
  options: { isLandlordRoute: false, isPublic: true },
  routeParamsStringifier: routeParams => {
    return {
      cityOrSearchCategory: routeParams.searchCategory.toString(),
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      searchCategory:
        parseRouteParamToEnum(
          routeParamsString.cityOrSearchCategory,
          ListingsSearchCategory,
        ) ?? ListingsSearchCategory.Empty,
    };
  },
});
